import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { commentQueryKeys } from 'lib/queryKeys';

import { getOfferCommentsCount } from 'services/comment';

const Comment = ({ children: count, offerId }) => {
  const { data: commentsCount } = useQuery({
    queryKey: commentQueryKeys.offer.count({ offerId }),
    queryFn: async ({ signal }) => {
      const result = await getOfferCommentsCount({ offerId }, { signal });

      return result.total;
    },
    enabled: false,
    initialData: count,
  });

  return (
    <div className="flex size-10 items-center justify-center gap-x-1">
      <Icon
        className="text-rd-primary-700 dark:text-rd-primary-700"
        name="forum"
      />
      <Text
        as="span"
        className="text-rd-primary-700 dark:text-rd-primary-700"
        size="size1"
        type="primary"
        bold
      >
        {commentsCount}
      </Text>
    </div>
  );
};

Comment.propTypes = {
  children: PropTypes.number.isRequired,
  offerId: PropTypes.number.isRequired,
};

export default Comment;
